var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnnonsesenterIkon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54 42.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f9615b;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M37.28,1.29V34.62c0,.72-.58,1.29-1.29,1.29h-.08c-.71,0-1.29-.58-1.29-1.29v-.06c-2.52-1.96-5.84-4.17-9.96-6.13-3.31-1.57-6.4-2.63-9.06-3.34-.5-.14-.85-.59-.85-1.11V11.93c0-.52,.35-.97,.85-1.11,2.66-.72,5.75-1.77,9.06-3.34,4.12-1.96,7.44-4.17,9.96-6.13v-.06c0-.72,.58-1.29,1.29-1.29h.08c.71,0,1.29,.58,1.29,1.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.91,12.19v29.3c0,.63-.51,1.15-1.15,1.15H7.6c-.63,0-1.15-.51-1.15-1.15V24.85c-3.6-.23-6.45-3.23-6.45-6.89,0-1.91,.77-3.63,2.02-4.89,1.25-1.25,2.98-2.02,4.89-2.02h4.85c.63,0,1.15,.51,1.15,1.15Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.49,30.04c-.18,0-.37-.04-.55-.12-.66-.3-.95-1.08-.64-1.74,1.47-3.18,2.24-6.72,2.24-10.22s-.77-7.04-2.24-10.22c-.3-.66-.01-1.44,.64-1.74,.66-.3,1.44-.01,1.74,.64,1.62,3.52,2.48,7.44,2.48,11.32s-.86,7.79-2.48,11.32c-.22,.48-.7,.76-1.19,.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.7,34.1c-.17,0-.34-.03-.51-.1-.67-.28-.98-1.05-.7-1.72,1.87-4.47,2.84-9.18,2.88-14.02,.04-5.05-.93-9.98-2.88-14.64-.28-.67,.03-1.44,.7-1.72s1.44,.03,1.72,.7c2.09,4.99,3.13,10.27,3.09,15.68-.04,5.18-1.08,10.23-3.09,15.01-.21,.5-.7,.8-1.21,.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnonsesenterIkon);
export default __webpack_public_path__ + "static/media/Annonsesenter_Ikon.dda879eb832e2ace2991d2a456cb4662.svg";
export { ForwardRef as ReactComponent };